// Copyright (c) 2017 Deere & Company

import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import t from 'tcomb';

const DealerHierarchyAccount = t.struct({
    dealer: Dealer,
    id: t.String
}, {
    name: 'DealerHierarchyAccount',
    strict: true
});

export const getDefaultState = () => new DealerHierarchyAccount({
    dealer: getDealerDefaultState(),
    id: ''
});

export default DealerHierarchyAccount;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-account.js